import { Budget } from "../../../state/types"
import { BudgetPDFPage } from './budgetPDFPage'
import { ItemsPDFWrapper } from '../../../../../features/ui'
import { CodedDataType } from '../../../../../tables'
import { Item } from "../../../../operations"

type Props = {
    id: string
    budget: Budget
    previewMode?: boolean
}

export const BudgetPDF = (props: Props) => {
    const { id, budget, previewMode } = props

    const renderPDFPage = (
        pageIndex: number,
        dataType: CodedDataType,
        items: Item[],
        pagesAmount: number
    ) => (
        <BudgetPDFPage
            pageIndex={pageIndex}
            budget={dataType as Budget}
            items={items}
            pagesAmount={pagesAmount}
        />
    )

    return (
        <ItemsPDFWrapper
            id={id}
            dataType={budget}
            items={budget.items}
            previewMode={previewMode}
            renderPDFPage={renderPDFPage}
        />
    )
}
